import { ADD_EDIT_CREDIT_NOTE, CREDIT_NOTE_LIST, TAX_INVOICE_DATA, TAX_INVOICE_DROPDOWN } from "./ApiRoutes";
import { authData } from "./services";

export const listOfCreditNote = async (data: object) => {
    const response = await authData.post(CREDIT_NOTE_LIST, data);
    return response?.data;
};

export const addCreditNote = async (data: object) => {
    const response = await authData.post(ADD_EDIT_CREDIT_NOTE, data);
    return response?.data;
};

export const editCreditNote = async (id: number, data: object) => {
    const response = await authData.put(`${ADD_EDIT_CREDIT_NOTE}/${id}`, data);
    return response?.data;
};

export const viewCreditNote = async (id: number) => {
    const response = await authData.get(`${ADD_EDIT_CREDIT_NOTE}/${id}`);
    return response?.data;
};
export const taxInvoiceDropdownApi = async () => {
  const response = await authData.get(`${TAX_INVOICE_DROPDOWN}`);
  return response?.data;
}
export const taxInvoiceDataApi = async (id: number) => {
  const response = await authData.get(`${TAX_INVOICE_DATA}${id}`);
  return response?.data;
};